// 引入刚刚封装好的axios
import service from './axios';

//此方法耦合度很低 适用于业务中绝大部分
export default function requestOfPost(url,data){
//参数 url：接口地址  data:传给后台的参数
    return service.post(url,data);
}


// WEBPACK FOOTER //
// ./src/axios/common.js